import { Form } from 'factorial-form'
import compact from 'lodash/compact'
import { makeObservable, observable } from 'mobx'
import type { IObservableArray } from 'mobx'

import { argumentsByOperator } from 'modules/reports/lib/Constants'
import type { ConditionParams } from 'modules/reports/store/models/Condition'
import type { FilterParams } from 'modules/reports/store/models/Filter'

class ConditionForm extends Form {
  arguments: IObservableArray<{
    use_variable: boolean
    value: string
  }> = observable([])

  static buildForms(filter: FilterParams): ConditionForm[] {
    return filter.map((condition: ConditionParams) => {
      const form = new ConditionForm({
        id: condition.id,
        path: condition.path,
        operator: condition.operator,
      })
      form.arguments.replace(condition.arguments || [])

      return form
    })
  }

  static convertToParams(forms: ConditionForm[]): ConditionParams[] | null | undefined {
    return compact(
      forms.map((form: ConditionForm) => {
        return form.getData()
      })
    )
  }

  constructor(values: Record<string, any>) {
    super(values, {
      id: 'string',
      path: 'string',
      operator: 'string',
    })
    makeObservable(this, {
      arguments: observable,
    })
  }

  updateWithArgs(values: Record<string, any>, args: string[]) {
    this.setValues(values)
    this.arguments = args as any
  }

  get isCompleted(): boolean {
    const { path, operator } = this.data()
    const numOfArgs = argumentsByOperator(operator)

    return !!path && !!operator && this.arguments.length === numOfArgs
  }

  getData(): ConditionParams | null | undefined {
    if (!this.isCompleted) return null

    return { ...this.data(), arguments: this.arguments } as any
  }
}

export default ConditionForm
